<template>
  <div class="dropdown" v-show="this.$store.getters.right__folder_tree && isShowNewFolder" @click="createNewFolder">
    <div class="dropdown-toggle">
      <i class="iconfont icon-folder-plus"></i>
      新建文件夹
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isShowNewFolder: Boolean
  },
  name: "NewFolder",
  methods: {
    createNewFolder() {
      this.$emit("createNewFolder");
    }
  }
};
</script>

<style scoped>
</style>